.dj{border:1px solid #ddd;}